import React from 'react';

/**
 * Proposed empty-state illustration — the tower on a horizon with an
 * unlit beacon. "Nothing on watch yet."
 */
export function DarkTower({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 120 80" fill="none" className={className} aria-hidden="true" focusable="false" data-id="element-189" data-mp="295vfheg9srqa">
      {/* horizon */}
      <path d="M2 70h116" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.35" data-id="element-190" data-mp="2e5zz3dch62kq" />
      {/* distant, unmonitored sites */}
      <path d="M14 70v-5M24 70v-3M96 70v-4M106 70v-2.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.22" data-id="element-191" data-mp="255lao547s7d0" />

      {/* unlit beacon */}
      <circle cx="60" cy="14" r="3" stroke="currentColor" strokeWidth="1.5" opacity="0.6" data-id="element-192" data-mp="1vbchrgb9uceb" />
      <path d="M60 17v5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.6" data-id="element-193" data-mp="1lega1ct75uat" />

      {/* platform */}
      <path d="M45 22h30l-4 6H49z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" data-id="element-194" data-mp="1w4roi9341zdx" />
      {/* tower body */}
      <path d="M50.5 28h19l3.5 42H47z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" data-id="element-195" data-mp="2azpkdbxgx6zr" />
      {/* lookout window */}
      <path d="M56.5 36h7v9h-7z" stroke="currentColor" strokeWidth="1.4" opacity="0.55" data-id="element-196" data-mp="1idwgez0frmbe" />
      {/* cross brace */}
      <path d="M48.5 54h23" stroke="currentColor" strokeWidth="1.4" opacity="0.4" data-id="element-197" data-mp="1s2xw0o32k1ou" />
    </svg>;
}